import { render } from "./ResetLogin.vue?vue&type=template&id=4f6e12b9&scoped=true&ts=true"
import script from "./ResetLogin.vue?vue&type=script&lang=ts"
export * from "./ResetLogin.vue?vue&type=script&lang=ts"

import "./ResetLogin.vue?vue&type=style&index=0&id=4f6e12b9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6e12b9"]])

export default __exports__